import type { RenamePreviewChange } from '@cli-types/core-engine/snapshots.js'

export function collectPreviewChanges(
  path: string,
  beforeContent: string,
  afterContent: string
): RenamePreviewChange[] {
  const beforeLines = beforeContent.split('\n')
  const afterLines = afterContent.split('\n')
  const maxLength = Math.max(beforeLines.length, afterLines.length)
  const changes: RenamePreviewChange[] = []

  for (let index = 0; index < maxLength; index++) {
    const before = beforeLines[index] ?? ''
    const after = afterLines[index] ?? ''

    if (before === after) {
      continue
    }

    changes.push({
      path,
      line: index + 1,
      before: before.trim(),
      after: after.trim()
    })
  }

  return changes
}
